import styled from 'styled-components'

export const ListRatings = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 1rem;
`
export const Category = styled.span`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: .875rem;
  color: #555555;
  margin: 0;
  margin-right: 5px;
`
export const MarginBottom = styled.div`
  margin-bottom: 5px;
`
